import React, { useState, useEffect } from "react";
// import Loading from "./Loading";
import Tour from "./Tour";

function App() {
  return <Tour />;
}

export default App;
